<template>
    <div :class="$style['headerTop-basket']">
        <v-icon style="z-index: 10; color: white" role="button" v-ripple @click="goBack">chevron_right</v-icon>
        <span style=" display: flex; justify-content: space-between;
                             align-items: center; margin-right: 15px; color: white">{{parseName(title)}}</span>
        <v-icon style="z-index: 20; color: white;position: absolute; left: 10px; top: 15px;"
                role="button" v-ripple @click="goHome">home
        </v-icon>
    </div>
</template>

<script>
    export default {
        name: "Header"
        , props: {
            'title': null
        }, methods: {
            parseName(input) {
                if (input == null) {
                    return ''
                } else return input.split(' | ')[1]
            },
            goBack() {
                this.$router.go(-1)
            },
            goHome() {
                this.$router.push("/main")
            },
        }
    }
</script>

<style module>
    .header-basket h2 {
        font-size: 12px;
        color: #000;
        font-weight: 100;
        text-align: justify;
    }

    .headerTop-basket {
        z-index: 1000;
        background: #4b4a4a;
        padding: 15px 10px;
        display: flex;
        position: sticky;
        top: 0;
    }
</style>